import axios from "axios";
import { config } from "../config";

export class QuestionsService {
  /*********** List ***********/
  public list = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + "questions");
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  public create = async (data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.post(serverUrl + "questions", data);
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  public update = async (id: number, data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.put(serverUrl + `questions/${id}`, data);
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };
}
